export const $ProfileSidebarModuleName = "profileSidebar";

export type TProfileSidebarState = {
    active: boolean;
};
